import { defineComponent, h, VNodeChildren } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { VNodeData } from 'vue/types/vnode.d';
import { ScimErrorLog } from '@/services/api/resources/sso-configuration';

interface LogTypeProps {
  log: ScimErrorLog;
}

export const LogType = defineComponent<LogTypeProps>({
  name: 'LogType',
  props: ['log'],
  setup(props) {
    return function render() {
      return h('span', { class: 'sso-scim-error-logs__log-type' }, [`${t(`sso.scim.error-logs-modal.types.${props.log.type}`)}: `]);
    };
  },
});

export function logType(data: VNodeData & { props: LogTypeProps }, children: VNodeChildren = []) {
  return h(LogType, data, children);
}
